import { gql } from '@apollo/client';

import {
  DefaultErrorFragmentDoc,
  IdentityRefFragmentDoc,
} from '@spotify/confidence-graphql';

// TODO(TASK-29635): Move to a .graphql file once the holdbacks schema drift in SurfaceCoordination.query.graphql is fixed
export const collectionEntryMetricFieldsFragment = gql`
  fragment CollectionEntryMetricFields on MetricsV1Metric {
    state
    factTable {
      ... on MetricsV1FactTable {
        __typename
        name
        displayName
      }
      ...DefaultError
    }
    owner {
      ...IdentityRef
      ...DefaultError
    }
    labels {
      key
      value
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
